module.exports = __webpack_public_path__ + "img/water-rat-ripples.9073b647d1ce44a9ecb4548bffe113d4.jpg";